import { render } from "./SegmentItemPreview.vue?vue&type=template&id=42989e3a&scoped=true&ts=true"
import script from "./SegmentItemPreview.vue?vue&type=script&lang=ts"
export * from "./SegmentItemPreview.vue?vue&type=script&lang=ts"

import "./SegmentItemPreview.vue?vue&type=style&index=0&id=42989e3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42989e3a"]])

export default __exports__